// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transaction-card {
    background-color: var(--bg-white);
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);
    overflow: hidden;
    transition: all 0.3s ease;
  }

  .transaction-card:hover {
    box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);
  }

  .transaction-card-header {
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.06) 0%, rgba(95, 184, 165, 0.06) 100%);
    padding: 18px 24px;
    border-bottom: 2px solid var(--border-gray);
  }

  .transaction-card-header h3 {
    margin: 0;
    color: var(--primary-teal);
    font-size: 1.25rem;
    font-weight: 600;
  }

  .transaction-card-body {
    padding: 24px;
  }

  .transaction-form {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .form-group label {
    font-size: 0.95rem;
    color: var(--primary-teal);
    font-weight: 600;
  }

  .form-group input {
    padding: 12px 14px;
    border: 1px solid var(--border-gray);
    border-radius: 10px;
    font-size: 0.98rem;
    transition: all 0.3s ease;
    background-color: var(--bg-white);
  }

  .form-group input:focus {
    outline: none;
    border-color: var(--primary-teal);
    box-shadow: 0 0 0 3px rgba(17, 69, 77, 0.1);
  }
  
  .transaction-error {
    color: var(--error);
    font-size: 0.95rem;
    padding: 8px 0;
    font-weight: 500;
  }

  .transaction-result {
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);
    padding: 14px;
    border-radius: 12px;
    font-size: 0.95rem;
    border: 1px solid var(--border-gray);
  }

  .tx-signature {
    font-family: 'Monaco', 'Menlo', monospace;
    word-break: break-all;
    display: block;
    background-color: rgba(17, 69, 77, 0.06);
    padding: 8px;
    border-radius: 8px;
    margin-top: 6px;
    color: var(--primary-teal);
  }

  .tx-status {
    font-weight: 600;
  }

  .tx-status-pending {
    color: var(--warning);
  }

  .tx-status-confirmed {
    color: var(--primary-teal-active);
  }

  .tx-status-finalized {
    color: var(--success);
  }

  .tx-status-failed {
    color: var(--error);
  }

  .button-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
  }

  .send-button {
    background-color: var(--primary-teal);
    color: white;
    border: none;
    padding: 14px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 0.98rem;
    font-weight: 500;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);
  }

  .send-button:hover:not(:disabled) {
    background-color: var(--primary-teal-light);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);
  }

  .send-button:disabled {
    background-color: var(--border-gray);
    color: var(--text-light);
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  .kit-button {
    background: linear-gradient(135deg, var(--accent-mint) 0%, var(--primary-teal-active) 100%);
    color: white;
  }

  .kit-button:hover:not(:disabled) {
    background: linear-gradient(135deg, var(--primary-teal-active) 0%, var(--accent-mint) 100%);
  }

  .transaction-card-message {
    color: var(--text-medium);
    font-style: italic;
    text-align: center;
    padding: 24px 0;
  }

  /* New styles for enhanced dual architecture demo */
  .architecture-log {
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);
    border: 1px solid var(--border-gray);
    border-radius: 12px;
    padding: 16px;
    margin: 20px 0;
    max-height: 220px;
    overflow-y: auto;
  }

  .log-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .log-header h5 {
    margin: 0;
    color: var(--primary-teal);
    font-size: 0.98rem;
    font-weight: 600;
  }

  .clear-log-button {
    background: var(--error);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 6px 12px;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .clear-log-button:hover {
    background: #c62828;
    transform: translateY(-1px);
  }

  .log-content {
    font-family: 'Monaco', 'Menlo', monospace;
    font-size: 0.85rem;
    line-height: 1.5;
  }

  .log-entry {
    color: var(--text-dark);
    margin-bottom: 4px;
    padding: 4px 0;
  }

  .button-section {
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);
    border: 1px solid var(--border-gray);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 16px;
  }

  .button-section h5 {
    margin: 0 0 12px 0;
    color: var(--primary-teal);
    font-size: 0.98rem;
    font-weight: 600;
  }

  .button-section:first-child {
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.05) 0%, rgba(26, 109, 122, 0.05) 100%);
    border-color: var(--primary-teal-light);
  }

  .button-section:last-child {
    background: linear-gradient(135deg, rgba(95, 184, 165, 0.05) 0%, rgba(42, 141, 156, 0.05) 100%);
    border-color: var(--accent-mint);
  }

  .new-method-button {
    background: linear-gradient(135deg, var(--primary-teal) 0%, var(--primary-teal-active) 100%);
    color: white;
  }

  .new-method-button:hover:not(:disabled) {
    background: linear-gradient(135deg, var(--primary-teal-light) 0%, var(--primary-teal-active) 100%);
  }

  .kit-pure-button {
    background: linear-gradient(135deg, var(--accent-mint) 0%, var(--primary-teal-active) 100%);
    color: white;
  }

  .kit-pure-button:hover:not(:disabled) {
    background: linear-gradient(135deg, var(--primary-teal-active) 0%, var(--accent-mint) 100%);
  }

  .architecture-info {
    background: linear-gradient(135deg, rgba(95, 184, 165, 0.1) 0%, rgba(42, 141, 156, 0.1) 100%);
    border: 1px solid var(--accent-mint);
    border-radius: 12px;
    padding: 16px;
    margin-top: 20px;
    text-align: center;
  }

  .architecture-info p {
    margin: 6px 0;
    font-size: 0.95rem;
    color: var(--text-dark);
  }

  .architecture-info strong {
    color: var(--primary-teal);
    font-weight: 600;
  }`, "",{"version":3,"sources":["webpack://./src/components/TransactionCard.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,6CAA6C;IAC7C,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,6FAA6F;IAC7F,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,iCAAiC;IACjC,2CAA2C;EAC7C;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,6FAA6F;IAC7F,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;EACtC;;EAEA;IACE,yCAAyC;IACzC,qBAAqB;IACrB,cAAc;IACd,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,4CAA4C;EAC9C;;EAEA;IACE,2CAA2C;IAC3C,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,oCAAoC;IACpC,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,2FAA2F;IAC3F,YAAY;EACd;;EAEA;IACE,2FAA2F;EAC7F;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,mDAAmD;EACnD;IACE,6FAA6F;IAC7F,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,6FAA6F;IAC7F,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6FAA6F;IAC7F,uCAAuC;EACzC;;EAEA;IACE,+FAA+F;IAC/F,gCAAgC;EAClC;;EAEA;IACE,4FAA4F;IAC5F,YAAY;EACd;;EAEA;IACE,kGAAkG;EACpG;;EAEA;IACE,2FAA2F;IAC3F,YAAY;EACd;;EAEA;IACE,2FAA2F;EAC7F;;EAEA;IACE,6FAA6F;IAC7F,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB","sourcesContent":[".transaction-card {\n    background-color: var(--bg-white);\n    border-radius: 16px;\n    box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);\n    overflow: hidden;\n    transition: all 0.3s ease;\n  }\n\n  .transaction-card:hover {\n    box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);\n  }\n\n  .transaction-card-header {\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.06) 0%, rgba(95, 184, 165, 0.06) 100%);\n    padding: 18px 24px;\n    border-bottom: 2px solid var(--border-gray);\n  }\n\n  .transaction-card-header h3 {\n    margin: 0;\n    color: var(--primary-teal);\n    font-size: 1.25rem;\n    font-weight: 600;\n  }\n\n  .transaction-card-body {\n    padding: 24px;\n  }\n\n  .transaction-form {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n  }\n\n  .form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .form-group label {\n    font-size: 0.95rem;\n    color: var(--primary-teal);\n    font-weight: 600;\n  }\n\n  .form-group input {\n    padding: 12px 14px;\n    border: 1px solid var(--border-gray);\n    border-radius: 10px;\n    font-size: 0.98rem;\n    transition: all 0.3s ease;\n    background-color: var(--bg-white);\n  }\n\n  .form-group input:focus {\n    outline: none;\n    border-color: var(--primary-teal);\n    box-shadow: 0 0 0 3px rgba(17, 69, 77, 0.1);\n  }\n  \n  .transaction-error {\n    color: var(--error);\n    font-size: 0.95rem;\n    padding: 8px 0;\n    font-weight: 500;\n  }\n\n  .transaction-result {\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);\n    padding: 14px;\n    border-radius: 12px;\n    font-size: 0.95rem;\n    border: 1px solid var(--border-gray);\n  }\n\n  .tx-signature {\n    font-family: 'Monaco', 'Menlo', monospace;\n    word-break: break-all;\n    display: block;\n    background-color: rgba(17, 69, 77, 0.06);\n    padding: 8px;\n    border-radius: 8px;\n    margin-top: 6px;\n    color: var(--primary-teal);\n  }\n\n  .tx-status {\n    font-weight: 600;\n  }\n\n  .tx-status-pending {\n    color: var(--warning);\n  }\n\n  .tx-status-confirmed {\n    color: var(--primary-teal-active);\n  }\n\n  .tx-status-finalized {\n    color: var(--success);\n  }\n\n  .tx-status-failed {\n    color: var(--error);\n  }\n\n  .button-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 12px;\n  }\n\n  .send-button {\n    background-color: var(--primary-teal);\n    color: white;\n    border: none;\n    padding: 14px;\n    border-radius: 10px;\n    cursor: pointer;\n    font-size: 0.98rem;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);\n  }\n\n  .send-button:hover:not(:disabled) {\n    background-color: var(--primary-teal-light);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);\n  }\n\n  .send-button:disabled {\n    background-color: var(--border-gray);\n    color: var(--text-light);\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n  }\n\n  .kit-button {\n    background: linear-gradient(135deg, var(--accent-mint) 0%, var(--primary-teal-active) 100%);\n    color: white;\n  }\n\n  .kit-button:hover:not(:disabled) {\n    background: linear-gradient(135deg, var(--primary-teal-active) 0%, var(--accent-mint) 100%);\n  }\n\n  .transaction-card-message {\n    color: var(--text-medium);\n    font-style: italic;\n    text-align: center;\n    padding: 24px 0;\n  }\n\n  /* New styles for enhanced dual architecture demo */\n  .architecture-log {\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);\n    border: 1px solid var(--border-gray);\n    border-radius: 12px;\n    padding: 16px;\n    margin: 20px 0;\n    max-height: 220px;\n    overflow-y: auto;\n  }\n\n  .log-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n  }\n\n  .log-header h5 {\n    margin: 0;\n    color: var(--primary-teal);\n    font-size: 0.98rem;\n    font-weight: 600;\n  }\n\n  .clear-log-button {\n    background: var(--error);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 6px 12px;\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n\n  .clear-log-button:hover {\n    background: #c62828;\n    transform: translateY(-1px);\n  }\n\n  .log-content {\n    font-family: 'Monaco', 'Menlo', monospace;\n    font-size: 0.85rem;\n    line-height: 1.5;\n  }\n\n  .log-entry {\n    color: var(--text-dark);\n    margin-bottom: 4px;\n    padding: 4px 0;\n  }\n\n  .button-section {\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);\n    border: 1px solid var(--border-gray);\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 16px;\n  }\n\n  .button-section h5 {\n    margin: 0 0 12px 0;\n    color: var(--primary-teal);\n    font-size: 0.98rem;\n    font-weight: 600;\n  }\n\n  .button-section:first-child {\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.05) 0%, rgba(26, 109, 122, 0.05) 100%);\n    border-color: var(--primary-teal-light);\n  }\n\n  .button-section:last-child {\n    background: linear-gradient(135deg, rgba(95, 184, 165, 0.05) 0%, rgba(42, 141, 156, 0.05) 100%);\n    border-color: var(--accent-mint);\n  }\n\n  .new-method-button {\n    background: linear-gradient(135deg, var(--primary-teal) 0%, var(--primary-teal-active) 100%);\n    color: white;\n  }\n\n  .new-method-button:hover:not(:disabled) {\n    background: linear-gradient(135deg, var(--primary-teal-light) 0%, var(--primary-teal-active) 100%);\n  }\n\n  .kit-pure-button {\n    background: linear-gradient(135deg, var(--accent-mint) 0%, var(--primary-teal-active) 100%);\n    color: white;\n  }\n\n  .kit-pure-button:hover:not(:disabled) {\n    background: linear-gradient(135deg, var(--primary-teal-active) 0%, var(--accent-mint) 100%);\n  }\n\n  .architecture-info {\n    background: linear-gradient(135deg, rgba(95, 184, 165, 0.1) 0%, rgba(42, 141, 156, 0.1) 100%);\n    border: 1px solid var(--accent-mint);\n    border-radius: 12px;\n    padding: 16px;\n    margin-top: 20px;\n    text-align: center;\n  }\n\n  .architecture-info p {\n    margin: 6px 0;\n    font-size: 0.95rem;\n    color: var(--text-dark);\n  }\n\n  .architecture-info strong {\n    color: var(--primary-teal);\n    font-weight: 600;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
